import NavBar from "./NavBar";
import Footer from "./Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <NavBar />

      <main className="flex-1 pt-36 pb-20 px-4 bg-[#042033]">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
            <p className="text-white/60">Last updated: December 3, 2025</p>
          </div>

          <div className="space-y-12 text-white/80 leading-relaxed">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                1. Introduction
              </h2>
              <p className="mb-4">
                Welcome to Akaram Radio ("we," "our," or "us"). We respect your
                privacy and are committed to protecting your personal data. This
                privacy policy will inform you as to how we look after your
                personal data when you visit our website (regardless of where
                you visit it from) and tell you about your privacy rights and
                how the law protects you.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                2. The Data We Collect
              </h2>
              <p className="mb-4">
                We may collect, use, store and transfer different kinds of
                personal data about you which we have grouped together follows:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <span className="text-white font-medium">Identity Data</span>{" "}
                  includes first name, last name, username or similar
                  identifier.
                </li>
                <li>
                  <span className="text-white font-medium">Contact Data</span>{" "}
                  includes email address and telephone numbers.
                </li>
                <li>
                  <span className="text-white font-medium">Technical Data</span>{" "}
                  includes internet protocol (IP) address, browser type and
                  version, time zone setting and location.
                </li>
                <li>
                  <span className="text-white font-medium">Usage Data</span>{" "}
                  includes information about how you use our website and
                  services.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                3. How We Use Your Data
              </h2>
              <p className="mb-4">
                We will only use your personal data when the law allows us to.
                Most commonly, we will use your personal data in the following
                circumstances:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  To provide the services you request (e.g., newsletter
                  subscription).
                </li>
                <li>To improve our website and listener experience.</li>
                <li>To comply with a legal or regulatory obligation.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                4. Data Security
              </h2>
              <p>
                We have put in place appropriate security measures to prevent
                your personal data from being accidentally lost, used or
                accessed in an unauthorized way, altered or disclosed. In
                addition, we limit access to your personal data to those
                employees, agents, contractors and other third parties who have
                a business need to know.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">
                5. Contact Us
              </h2>
              <p>
                If you have any questions about this privacy policy or our
                privacy practices, please contact us at: <br />
                <span className="text-cyan-400">privacy@akaram.no</span>
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
